// extracted by mini-css-extract-plugin
export default {"Club888":"Club888_Club888__lOo7n","Logo":"Club888_Logo__9f9gV"};